import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CalculatorCaseSelectModalStore } from './calculator-case-select-modal.store';
import { LoadingSpinnerSelectComponent } from '../loading-spinner-select/loading-spinner-select.component';
import { CaseDto } from '../../Models/CaseDto';

@Component({
  selector: 'debtor-panel-calculator-case-select-modal',
  templateUrl: './calculator-case-select-modal.component.html',
  styleUrls: ['./calculator-case-select-modal.component.scss'],
  providers: [TranslateService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    LoadingSpinnerSelectComponent,
  ],
})
export class CalculatorCaseSelectModalComponent {
  private readonly fb = inject(FormBuilder);
  private readonly dialogRef = inject(MatDialogRef<CalculatorCaseSelectModalComponent>);
  protected readonly store = inject(CalculatorCaseSelectModalStore);
  protected readonly form: FormGroup = this.fb.group({
    case: ['', Validators.required],
  });

  public data: { myObjectHolder: CaseDto[] } = inject(MAT_DIALOG_DATA);

  constructor() {
    this.store.loadCaseDto(this.data.myObjectHolder);
  }

  @HostListener('document:keydown.escape', ['$event'])
  protected onEscPressed(event: KeyboardEvent): void {
    this.dialogRef.close();
  }

  protected onCloseClick(): void {
    this.dialogRef.close();
  }

  protected onSubmit(): void {
    this.dialogRef.close();
    this.store.goToCalculator(this.form.get('case')?.value);
  }
}
